<template>
    <tw-modal :show="show" @close="$emit('close')" title="Create a League">
        <button class="absolute top-1 right-1 text-xl rounded-full bg-racing-stars-yellow" @click="$emit('close')">
            <XCircleIcon class="w-8 text-black"/>
        </button>
        <jet-form-section @submitted="storeLeague">
            <template #form>
                <div class="mt-1 relative rounded-md shadow-sm mb-4">
                    <jet-label for="name" value="League Name" />
                    <jet-input :ignore-dark-mode="true" name="name" v-model="createForm.name" placeholder="Enter a league name" class="mt-1 block w-full p-2" />
                    <div v-show="createForm.errors.name" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                    </div>
                    <jet-input-error :message="createForm.errors.name" class="mt-2" />
                </div>
                <div class="mt-1 relative rounded-md shadow-sm mb-4">
                    <jet-label for="description" value="League Description" />
                    <jet-input :ignore-dark-mode="true" v-model="createForm.description" placeholder="Enter a description" class="mt-1 block w-full p-2" />
                    <div v-show="createForm.errors.description" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                    </div>
                    <jet-input-error :message="createForm.errors.description" class="mt-2" />
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <jet-label for="cover_picture" value="League Cover Picture" />
                    <input type="file" class="hidden" name="cover_picture" v-on:change="createPhotoPreview" ref="cover_picture">
                    <div class="mt-2 mb-2" v-show="photoPreview">
                        <span class="block w-[350px] h-40" :style="'background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url(\'' + photoPreview + '\');'">
                        </span>
                    </div>
                    <button type="button" @click.prevent="selectNewPhoto" class="w-full px-4 py-2 mt-2 font-semibold text-xs uppercase tracking-widest bg-racing-stars-yellow border border-black text-black rounded-md">Select a cover image</button>
                    <jet-input-error :message="createForm.errors.cover_picture" class="mt-2" />
                </div>
            </template>
            <template #actions>
                <div class="flex justify-end space-x-2">
                    <label class="mr-4 flex items-center">
                        <jet-checkbox v-model="createForm.public" name="public" :ignore-dark-mode="true" class="mt-1 block p-2 text-black my-auto h-6 w-6 disabled:bg-gray-600"/>
                        <span class="ml-1 text-sm text-gray-600 transition duration-500 ease-in-out dark:text-white">Public</span>
                    </label>
                    <jet-button class="text-right" :ignore-dark-mode="true" :class="{ 'opacity-25': createForm.processing }" :disabled="createForm.processing">
                    Create
                    </jet-button>
                </div>
            </template>
        </jet-form-section>
    </tw-modal>
</template>
<script>
import { getCurrentInstance } from 'vue'
import JetInput from '@/Jetstream/Input.vue'
import JetTextarea from '@/Jetstream/Textarea.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import TwModal from '@/Global/Elements/TwModal.vue'
import { ExclamationCircleIcon, XCircleIcon } from '@heroicons/vue/solid'
import { Inertia } from '@inertiajs/inertia'
import { ref } from 'vue';

export default {
    emits: ['close'],

    props: {
        show: {
            type: Boolean,
            default: false,
        }
    },

    components: {
        JetInput,
        JetTextarea,
        JetInputError,
        JetButton,
        JetLabel,
        JetFormSection,
        TwModal,
        JetCheckbox,
        ExclamationCircleIcon,
        Inertia,
        XCircleIcon
    },

    setup(props, { emit }) {


        const createForm = Inertia.form({
            name: null,
            public: null,
            description: null,
            cover_picture: null
        })

        const photoPreview = ref(null);
        const cover_picture = ref(null);

        function storeLeague() {
            createForm.post(route('api.myleagues.store'), {
                onSuccess: () => {
                    createForm.reset()
                    emit('close')
                }
            })
        }

        function selectNewPhoto() {
            cover_picture.value.click();
        }
        function createPhotoPreview() {
            const photo = cover_picture.value.files[0];
            if (!photo) return;
            const reader = new FileReader();
            reader.onload = (e) => {
                photoPreview.value = e.target.result;
            };
            reader.readAsDataURL(photo);
            createForm.cover_picture = photo;
        }

        return {
            createForm,
            storeLeague,
            photoPreview,
            createPhotoPreview,
            selectNewPhoto,
            cover_picture
        }
    }
}

</script>
